"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputProps = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_number_format_1 = __importDefault(require("react-number-format"));
var NumberFormatCustom = react_1.default.forwardRef(function (props, ref) {
    var onChange = props.onChange, other = __rest(props, ["onChange"]);
    return ((0, jsx_runtime_1.jsx)(react_number_format_1.default, __assign({}, other, { getInputRef: ref, onValueChange: function (values) {
            onChange({
                target: {
                    name: props.name,
                    value: values.value,
                },
            });
        }, isNumericString: true })));
});
var phoneInputProps = {
    format: '+1 (###) ###-####',
};
var currencyInputProps = {
    fixedDecimalScale: true,
    thousandSeparator: true,
    decimalScale: 2,
    prefix: '$',
};
var percentageInputProps = {
    thousandSeparator: true,
    decimalScale: 0,
    suffix: '%',
};
var numberInputProps = {
    thousandSeparator: true,
    decimalScale: 2,
};
exports.inputProps = {
    phone: {
        inputComponent: NumberFormatCustom,
        inputProps: phoneInputProps,
    },
    currency: {
        inputComponent: NumberFormatCustom,
        inputProps: currencyInputProps,
    },
    percentage: {
        inputComponent: NumberFormatCustom,
        inputProps: percentageInputProps,
    },
    number: {
        inputComponent: NumberFormatCustom,
        inputProps: numberInputProps,
    },
};
